const centroid = points =>
  points.reduce(([x, y], [prevX, prevY]) => [x + prevX, y + prevY], [0, 0]).map(n => n / points.length);

export const assignParentPosition = (node, _index, allNodes) => {
  const parent = Object.values(allNodes).find(n => n.children.includes(node.id));
  let parentCenter = 0;

  if (parent) {
    parent.children.forEach(childId => {
      const childNode = allNodes[childId];
      const atoms = Object.values(childNode.drawnMol.atoms);
      const parentPoints = atoms.map(atom => atom.pos);
      parentCenter = centroid(parentPoints)[1];
      childNode.positionInParent = parentCenter;
    });
    parent.children
      .sort((a, b) => {
        const nodeA = allNodes[a];
        const nodeB = allNodes[b];
        if (nodeA.positionInParent > nodeB.positionInParent) {
          return 1;
        }
        return -1;
      })
      .forEach((id, index) => {
        const node = allNodes[id];
        node.indexInParent = index;
      });
  }
  return { node, allNodes };
};

export const assignLayeringOrder = ({ node, allNodes }) => {
  let factor = 1;
  let parentIndex = 0;

  let parent = Object.values(allNodes).find(n => n.children.includes(node.id));
  parentIndex += node.indexInParent || 0;
  const isParentOf = parentId => n => n.children.includes(parentId);
  while (parent) {
    factor *= 10;
    parentIndex += factor * (parent.indexInParent || 0);
    parent = Object.values(allNodes).find(isParentOf(parent.id));
  }
  node.layeringOrder = parentIndex;
  return { node, allNodes };
};
